import { Bot, Clock, Image, Mic, Type } from "lucide-react";
import type { FluxoBlockType } from "@/hooks/useFluxos";

interface BlockMeta {
  label: string;
  icon: React.ReactNode;
}

export const BLOCK_META: Record<FluxoBlockType, BlockMeta> = {
  texto: { label: "Texto", icon: <Type size={16} /> },
  imagem: { label: "Imagem", icon: <Image size={16} /> },
  audio: { label: "Áudio", icon: <Mic size={16} /> },
  delay: { label: "Delay", icon: <Clock size={16} /> },
  assistente: { label: "Ativar Assistente", icon: <Bot size={16} /> },
};

export const BLOCK_TYPES: FluxoBlockType[] = [
  "texto",
  "imagem",
  "audio",
  "delay",
  "assistente",
];
